import React from 'react';
import { ProviderParams } from '../models/react';
import { PushNotificationContextType } from '../models/push-notification';

const PushNotificationContext = React.createContext<PushNotificationContextType | undefined>(undefined);
export function usePushNotificationContext() {
    
    const context =  React.useContext(PushNotificationContext);
    context?.AskPermissionToNotify()
    return context

}


export default function PushNotificationProvider({ children }: ProviderParams) {
    const [permission, setPermission] = React.useState<string>('started');

    function AskPermissionToNotify() {
        if (!("Notification" in window)) {
            console.log("This browser does not support desktop notification");
        } else if (Notification.permission === "granted") {
            setPermission('granted')
        } else if (Notification.permission !== "denied" && permission !== 'started') {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted" || permission === "default") {
                    setPermission(permission)
                } else {
                    setPermission(permission)
                }
            });
        }
    }

    function getBackToTabOnClick(notification: Notification) {
        notification.onclick = (event) => {
            window.focus();
            notification.close();
        }
    }

    function sendPushNotification(title: string, body: string, tag: string, callback?: (notification: Notification | { error: string }) => void) {
        let pushNotification: Notification;
        if (permission === "granted") {
            pushNotification = new Notification(title, { body, tag });
            getBackToTabOnClick(pushNotification)
            if (callback) callback(pushNotification || { error: "Your notification was not sent. Verify the browser permission." })
        }

    }
    return (
        <PushNotificationContext.Provider value={{ sendPushNotification, AskPermissionToNotify }}>
            {children}
        </PushNotificationContext.Provider>
    );
}